import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import { Box } from 'home/useBoxes';
import React from 'react';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import { BoxStatus } from 'home/useSubBoxStatuses';

interface Props {
  box: Box;
  status: BoxStatus;
  isDialogOpen: boolean;
  onDialogClose: () => void;
  onOk: () => void;
  isLoading: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  unlockBtn: {
    backgroundColor: ({ status }: Props) =>
      status.isUnlocked
        ? theme.palette.success.light
        : theme.palette.error.light,
  },
}));

const UnlockDialog = (props: Props) => {
  const { isDialogOpen, onDialogClose, onOk, box, isLoading, status } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      closeAfterTransition
      aria-labelledby="unlock-confirm"
      aria-describedby="unlock-confirm"
      open={isDialogOpen}
      onClose={onDialogClose}
    >
      <DialogTitle id="alert-dialog-title">
        {status.isUnlocked ? '鍵施錠確認' : '鍵解錠確認'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-name">
          {`ボックス: ${box.name}`}
        </DialogContentText>
        <DialogContentText id="alert-dialog-imei">
          {`IMEI: ${box.imei}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          onClick={onDialogClose}
          startIcon={<CloseIcon />}
        >
          キャンセル
        </Button>
        <Button
          disabled={isLoading}
          onClick={onOk}
          className={classes.unlockBtn}
          startIcon={status.isUnlocked ? <LockIcon /> : <LockOpenIcon />}
        >
          {status.isUnlocked ? '施錠する' : '解錠する'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnlockDialog;
